import type * as React from 'react';
import { ISeoLink } from '../../types/newbuilding/seoLink';
import { Link } from '../Link';

import * as styles from './SeoLinks.css';

interface ISeoLinksProps {
  links: ISeoLink[];
}
export const SeoLinks = (props: ISeoLinksProps): React.JSX.Element => {
  return (
    <div className={styles['links']}>
      {props.links.map(link => (
        <div key={link.link} className={styles['link']}>
          <Link target="_blank" url={link.link}>
            {link.title}
          </Link>
        </div>
      ))}
    </div>
  );
};
